export class Icons {
    public static readonly Add = 'Add';
    public static readonly AddCircle = 'ZoomIn';
    public static readonly Alert = 'Alert';
    public static readonly AlertError = 'AlertError';
    public static readonly AlertTriangle = 'AlertTriangle';
    public static readonly AlertWarning = 'AlertWarning';
    public static readonly BackgroundWavesMask = 'BackgroundWavesMask';
    public static readonly Bell = 'Bell';
    public static readonly Calculator = 'Calculator';
    public static readonly Calendar = 'Calendar';
    public static readonly CalendarCheck = 'CalendarCheck';
    public static readonly Camera = 'Camera';
    public static readonly CameraRoll = 'CameraRoll';
    public static readonly Chat = 'Chat';
    public static readonly CheckboxCheckmark = 'CheckboxCheckmark';
    public static readonly CheckboxDash = 'CheckboxDash';
    public static readonly Checkmark = 'Checkmark';
    public static readonly CheckmarkCircle = 'CheckmarkCircle';
    public static readonly CheckmarkCircleLarge = 'CheckmarkCircleLarge';
    public static readonly CheckmarkCircleSmall = 'CheckmarkCircleSmall';
    public static readonly CheckmarkCircleWithBubbles = 'CheckmarkCircleWithBubbles';
    public static readonly CheckmarkGreen = 'CheckmarkGreen';
    public static readonly CheckmarkSmall = 'CheckmarkSmall';
    public static readonly ChevronDown = 'ChevronDown';
    public static readonly ChevronLeft = 'ChevronLeft';
    public static readonly ChevronRight = 'ChevronRight';
    public static readonly ChevronUp = 'ChevronUp';
    public static readonly Circle = 'Circle';
    public static readonly CircleInfo = 'CircleInfo';
    public static readonly CircleQuestion = 'CircleQuestion';
    public static readonly CircleSmall = 'CircleSmall';
    public static readonly Clock = 'Clock';
    public static readonly ClockSmall = 'ClockSmall';
    public static readonly Close = 'Close';
    public static readonly CloseSmall = 'CloseSmall';
    public static readonly CombinedDocs = 'CombinedDocs';
    public static readonly Compass = 'Compass';
    public static readonly Dollar = 'Dollar';
    public static readonly DollarLarge = 'DollarLarge';
    public static readonly Edit = 'Edit';
    public static readonly EqualSign = 'EqualSign';
    public static readonly ExclamationCircle = 'ExclamationCircle';
    public static readonly Export = 'Export';
    public static readonly ExportSimple = 'ExportSimple';
    public static readonly FastTrackLogo = 'FastTrackLogo';
    public static readonly FileInvoiceDollar = 'FileInvoiceDollar';
    public static readonly Filter = 'Filter';
    public static readonly FirstPage = 'FirstPage';
    public static readonly FullScreen = 'FullScreen';
    public static readonly Gear = 'Gear';
    public static readonly Hamburger = 'Hamburger';
    public static readonly HandHoldingUsd = 'HandHoldingUsd';
    public static readonly Hourglass = 'Hourglass';
    public static readonly ImageFile = 'ImageFile';
    public static readonly IndividualDocs = 'IndividualDocs';
    public static readonly Info = 'Info';
    public static readonly InfoCircle = 'InfoCircle';
    public static readonly Key = 'Key';
    public static readonly LastPage = 'LastPage';
    public static readonly LeftArrow = 'LeftArrow';
    public static readonly LeftArrowSmall = 'LeftArrowSmall';
    public static readonly Lock = 'Lock';
    public static readonly Lsq = 'Lsq';
    public static readonly Mail = 'Mail';
    public static readonly MailSmall = 'MailSmall';
    public static readonly MinusSign = 'MinusSign';
    public static readonly Mobile = 'Mobile';
    public static readonly MultiplySign = 'MultiplySign';
    public static readonly NoDataCheckedRows = 'NoDataCheckedRows';
    public static readonly NoDataReport = 'NoDataReport';
    public static readonly NotificationActive = 'NotificationActive';
    public static readonly NotificationInactive = 'NotificationInactive';
    public static readonly Paperclip = 'Paperclip';
    public static readonly ParenthesesClosed = 'ParenthesesClosed';
    public static readonly ParenthesesOpen = 'ParenthesesOpen';
    public static readonly Person = 'Person';
    public static readonly PersonLarge = 'PersonLarge';
    public static readonly Phone = 'Phone';
    public static readonly PhoneSmall = 'PhoneSmall';
    public static readonly PiggyBank = 'PiggyBank';
    public static readonly PoweredByLsq = 'PoweredByLsq';
    public static readonly Print = 'Print';
    public static readonly Puzzle = 'Puzzle';
    public static readonly QuestionCircleLight = 'QuestionCircleLight';
    public static readonly RadioButtonActive = 'RadioButtonActive';
    public static readonly RadioButtonInactive = 'RadioButtonInactive';
    public static readonly RightArrow = 'RightArrow';
    public static readonly RightArrowSmall = 'RightArrowSmall';
    public static readonly Rotate = 'Rotate';
    public static readonly Search = 'Search';
    public static readonly SearchInvoices = 'SearchInvoices';
    public static readonly SearchLarge = 'SearchLarge';
    public static readonly Spreadsheet = 'Spreadsheet';
    public static readonly SquareBox = 'SquareBox';
    public static readonly Star = 'Star';
    public static readonly SwitchCustomers = 'SwitchCustomers';
    public static readonly ThumbsUp = 'ThumbsUp';
    public static readonly ToggleOff = 'ToggleOff';
    public static readonly ToggleOn = 'ToggleOn';
    public static readonly Trash = 'Trash';
    public static readonly TvLight = 'TvLight';
    public static readonly Upload = 'Upload';
    public static readonly UploadLarge = 'UploadLarge';
    public static readonly User = 'User';
    public static readonly View = 'View';
    public static readonly XCircle = 'XCircle';
    public static readonly ZoomIn = 'ZoomIn';
    public static readonly ZoomOut = 'ZoomOut';

    public static readonly FaArrowRight = 'FaArrowRight';
    public static readonly FaTrashAlt = 'FaTrashAlt';
    public static readonly FaFileDownloadSolid = 'FaFileDownloadSolid';
    public static readonly FaCalendarAlt = 'FaCalendarAlt';
    public static readonly FaChevronRight = 'FaChevronRight';
    public static readonly FaCog = 'FaCog';
    public static readonly FaEdit = 'FaEdit';
    public static readonly FaExclamationCircle = 'FaExclamationCircle';
    public static readonly FaExclamationTriangle = 'FaExclamationTriangle';
    public static readonly FaExclamationTriangleSolid = 'FaExclamationTriangleSolid';
    public static readonly FaExternalLink = 'FaExternalLink';
    public static readonly FaHashtag = 'FaHashtag';
    public static readonly FaInfoCircle = 'FaInfoCircle';
    public static readonly FaMagnifyingGlassSolid = 'FaMagnifyingGlassSolid';
    public static readonly FaMoneyCheck = 'FaMoneyCheck';
    public static readonly FaPercent = 'FaPercent';
    public static readonly FaPlusCircle = 'FaPlusCircle';
    public static readonly FaSignInAlt = 'FaSignInAlt';
    public static readonly FaSortDown = 'FaSortDown';
    public static readonly FaUsdCircle = 'FaUsdCircle';
    public static readonly FaUserPlus = 'FaUserPlus';
    public static readonly FaUserSlash = 'FaUserSlash';
    public static readonly FaPlayCircle = 'FaPlayCircle';
    public static readonly FaFileCsvSolid = 'FaFileCsvSolid';
    public static readonly FaFileExcelSolid = 'FaFileExcelSolid';
}

const basePath = 'libs/common-ui/src/assets/images/icons/svg';
const fontAwesomePath = 'libs/common-ui/src/assets/images/icons/svg/font-awesome';

export class IconPaths {
    public static readonly Add = `${basePath}/add.svg`;
    public static readonly Alert = `${basePath}/alert.noFill.svg`;
    public static readonly AlertError = `${basePath}/alert.red.svg`;
    public static readonly AlertTriangle = `${basePath}/alertTriangle.svg`;
    public static readonly AlertWarning = `${basePath}/alert.svg`;
    public static readonly BackgroundWavesMask = `${basePath}/background-waves-mask.svg`;
    public static readonly Bell = `${basePath}/bell.svg`;
    public static readonly Calculator = `${basePath}/calculator-regular.svg`;
    public static readonly Calendar = `${basePath}/calendar.svg`;
    public static readonly CalendarCheck = `${basePath}/calendar-check-light.svg`;
    public static readonly Camera = `${basePath}/camera.svg`;
    public static readonly CameraRoll = `${basePath}/roll-film.svg`;
    public static readonly Chat = `${basePath}/chat.svg`;
    public static readonly CheckboxCheckmark = `${basePath}/checkbox-checkmark.svg`;
    public static readonly CheckboxDash = `${basePath}/checkbox-dash.svg`;
    public static readonly Checkmark = `${basePath}/checkmark.svg`;
    public static readonly CheckmarkCircle = `${basePath}/checkmarkCircle.svg`;
    public static readonly CheckmarkCircleLarge = `${basePath}/checkmarkCircle-lg.svg`;
    public static readonly CheckmarkCircleSmall = `${basePath}/checkmarkCircle-sm.svg`;
    public static readonly CheckmarkCircleWithBubbles = `${basePath}/checkmarkCircleWithBubbles.svg`;
    public static readonly CheckmarkGreen = `${basePath}/checkmark-green.svg`;
    public static readonly CheckmarkSmall = `${basePath}/checkmark-sm.svg`;
    public static readonly ChevronDown = `${basePath}/chevron-down.svg`;
    public static readonly ChevronLeft = `${basePath}/chevron-up.svg`;
    public static readonly ChevronRight = `${basePath}/chevron-up.svg`;
    public static readonly ChevronUp = `${basePath}/chevron-up.svg`;
    public static readonly Circle = `${basePath}/circle.svg`;
    public static readonly CircleInfo = `${basePath}/DBA.svg`;
    public static readonly CircleQuestion = `${basePath}/info.svg`;
    public static readonly CircleSmall = `${basePath}/circle-sm.svg`;
    public static readonly Clock = `${basePath}/pendingCircle.svg`;
    public static readonly ClockSmall = `${basePath}/pendingCircle-sm.svg`;
    public static readonly Close = `${basePath}/close.svg`;
    public static readonly CloseSmall = `${basePath}/close-sm.svg`;
    public static readonly CombinedDocs = `${basePath}/combinedDocs.svg`;
    public static readonly Compass = `${basePath}/compass_logo_green.svg`;
    public static readonly Dollar = `${basePath}/dollar.svg`;
    public static readonly DollarLarge = `${basePath}/dollar-lg.svg`;
    public static readonly Edit = `${basePath}/edit.svg`;
    public static readonly EqualSign = `${basePath}/equalSign.svg`;
    public static readonly ExclamationCircle = `${basePath}/exclamation-circle-regular.svg`;
    public static readonly Export = `${basePath}/export.svg`;
    public static readonly ExportSimple = `${basePath}/export-simple.svg`;
    public static readonly FastTrackLogo = `${basePath}/fasttrack-logo.svg`;
    public static readonly FileInvoiceDollar = `${basePath}/file-invoice-dollar-light.svg`;
    public static readonly Filter = `${basePath}/filter.svg`;
    public static readonly FirstPage = `${basePath}/first-page.svg`;
    public static readonly FullScreen = `${basePath}/fullScreen.svg`;
    public static readonly Gear = `${basePath}/gear.svg`;
    public static readonly Hamburger = `${basePath}/hamburger.svg`;
    public static readonly HandHoldingUsd = `${basePath}/hand-holding-usd-light.svg`;
    public static readonly Hourglass = `${basePath}/hourglass.svg`;
    public static readonly ImageFile = `${basePath}/file-image-regular.svg`;
    public static readonly IndividualDocs = `${basePath}/individualDocs.svg`;
    public static readonly Info = `${basePath}/info.svg`;
    public static readonly InfoCircle = `${basePath}/infoCircle.svg`;
    public static readonly Key = `${basePath}/key.svg`;
    public static readonly LastPage = `${basePath}/last-page.svg`;
    public static readonly LeftArrow = `${basePath}/leftArrow.svg`;
    public static readonly LeftArrowSmall = `${basePath}/leftArrow-sm.svg`;
    public static readonly Lock = `${basePath}/lock.svg`;
    public static readonly Lsq = `${basePath}/lsq.svg`;
    public static readonly Mail = `${basePath}/mail.svg`;
    public static readonly MailSmall = `${basePath}/mail-sm.svg`;
    public static readonly MinusSign = `${basePath}/minusSign.svg`;
    public static readonly Mobile = `${basePath}/mobile.svg`;
    public static readonly MultiplySign = `${basePath}/multiply.svg`;
    public static readonly NoDataCheckedRows = `${basePath}/noDataCheckedRows.svg`;
    public static readonly NoDataReport = `${basePath}/noDataReport.svg`;
    public static readonly NotificationActive = `${basePath}/bellNotification-active.svg`;
    public static readonly NotificationInactive = `${basePath}/bellNotification-inactive.svg`;
    public static readonly Paperclip = `${basePath}/paperclip.svg`;
    public static readonly ParenthesesClosed = `${basePath}/parentheses-closed.svg`;
    public static readonly ParenthesesOpen = `${basePath}/parentheses-open.svg`;
    public static readonly Person = `${basePath}/person.svg`;
    public static readonly PersonLarge = `${basePath}/person.lg.svg`;
    public static readonly Phone = `${basePath}/phone.svg`;
    public static readonly PhoneSmall = `${basePath}/phone-sm.svg`;
    public static readonly PiggyBank = `${basePath}/piggy-bank-light.svg`;
    public static readonly PoweredByLsq = `${basePath}/powered-by-lsq.svg`;
    public static readonly Print = `${basePath}/print.svg`;
    public static readonly Puzzle = `${basePath}/puzzle.svg`;
    public static readonly QuestionCircleLight = `${basePath}/question-circle-light.svg`;
    public static readonly RadioButtonActive = `${basePath}/radioButton-active.svg`;
    public static readonly RadioButtonInactive = `${basePath}/radioButton-inactive.svg`;
    public static readonly RightArrow = `${basePath}/rightArrow.svg`;
    public static readonly RightArrowSmall = `${basePath}/rightArrow-sm.svg`;
    public static readonly Rotate = `${basePath}/rotate.svg`;
    public static readonly Search = `${basePath}/search.svg`;
    public static readonly SearchInvoices = `${basePath}/searchManually.svg`;
    public static readonly SearchLarge = `${basePath}/search-lg.svg`;
    public static readonly Spreadsheet = `${basePath}/spreadsheet.svg`;
    public static readonly SquareBox = `${basePath}/square-box.svg`;
    public static readonly Star = `${basePath}/star.svg`;
    public static readonly SwitchCustomers = `${basePath}/switchCustomers.svg`;
    public static readonly ThumbsUp = `${basePath}/thumbs-up-light.svg`;
    public static readonly ToggleOff = `${basePath}/toggle-off.svg`;
    public static readonly ToggleOn = `${basePath}/toggle-on.svg`;
    public static readonly Trash = `${basePath}/trash.svg`;
    public static readonly TvLight = `${basePath}/tv-light.svg`;
    public static readonly Upload = `${basePath}/upload.svg`;
    public static readonly UploadLarge = `${basePath}/upload-lg.svg`;
    public static readonly User = `${basePath}/user.svg`;
    public static readonly View = `${basePath}/view.svg`;
    public static readonly XCircle = `${basePath}/declinedCircle.svg`;
    public static readonly ZoomIn = `${basePath}/zoomIn.svg`;
    public static readonly ZoomOut = `${basePath}/zoomOut.svg`;

    public static readonly FaArrowRight = `${fontAwesomePath}/fa-arrow-right.svg`;
    public static readonly FaTrashAlt = `${fontAwesomePath}/fa-trash-alt.svg`;
    public static readonly FaFileDownloadSolid = `${fontAwesomePath}/fa-file-download-solid.svg`;
    public static readonly FaCalendarAlt = `${fontAwesomePath}/fa-calendar-alt-regular.svg`;
    public static readonly FaChevronRight = `${fontAwesomePath}/fa-chevron-right-light.svg`;
    public static readonly FaCog = `${fontAwesomePath}/cog-regular.svg`;
    public static readonly FaEdit = `${fontAwesomePath}/fa-edit.svg`;
    public static readonly FaExclamationCircle = `${fontAwesomePath}/fa-exclamation-circle.svg`;
    public static readonly FaExclamationTriangle = `${fontAwesomePath}/fa-exclamation-triangle.svg`;
    public static readonly FaExclamationTriangleSolid = `${fontAwesomePath}/fa-exclamation-triangle-solid.svg`;
    public static readonly FaExternalLink = `${fontAwesomePath}/fa-external-link.svg`;
    public static readonly FaHashtag = `${fontAwesomePath}/hashtag-regular.svg`;
    public static readonly FaInfoCircle = `${fontAwesomePath}/fa-info-circle.svg`;
    public static readonly FaMagnifyingGlassSolid = `${fontAwesomePath}/magnifying-glass-solid.svg`;
    public static readonly FaMoneyCheck = `${fontAwesomePath}/fa-money-check.svg`;
    public static readonly FaPercent = `${fontAwesomePath}/fa-percent.svg`;
    public static readonly FaPlusCircle = `${fontAwesomePath}/fa-plus-circle.svg`;
    public static readonly FaSignInAlt = `${fontAwesomePath}/fa-sign-in-alt.svg`;
    public static readonly FaSortDown = `${fontAwesomePath}/fa-sort-down.svg`;
    public static readonly FaUsdCircle = `${fontAwesomePath}/fa-usd-circle.svg`;
    public static readonly FaUserPlus = `${fontAwesomePath}/fa-user-plus.svg`;
    public static readonly FaUserSlash = `${fontAwesomePath}/fa-user-slash.svg`;
    public static readonly FaPlayCircle = `${fontAwesomePath}/play-circle-regular.svg`;
    public static readonly FaFileCsvSolid = `${fontAwesomePath}/file-csv-solid.svg`;
    public static readonly FaFileExcelSolid = `${fontAwesomePath}/file-excel-solid.svg`;
}
